<div class="background-sura">
<div class="container pl-0 pr-0">
  <div style="padding: 10px 0px"></div>
    <form class="container-fluid" autocomplete="off">
		<div class="row">
			<div class="col-xs-12 col-lg-6 col-md-6">
				<div class="row">
					<div class="binfo">
						<div class="form-group ">
							<mat-form-field class="col-lg-12" appearance="outline">
							<mat-label>NRO. ASAMBLEA</mat-label>
							<input matInput [(ngModel)]="newAsistente.idAsamblea" name="asamblea" [formControl]="nroAsambleaValidacion"
								required maxlength="6" (keypress)="fnKeyDownNumeric($event)" (keyup)="fnNumericMobile($event)"
								(input)="fnInputMaxLength($event);">
							<mat-error *ngIf="nroAsambleaValidacion.invalid">{{getErrorMessageNroAsamblea()}}</mat-error>
							</mat-form-field>
						</div>
						<div class="form-group ">
							<mat-form-field class="col-lg-12" appearance="outline">
							<mat-label>NRO. DOCUMENTO</mat-label>
							<input matInput [(ngModel)]="newAsistente.numeroDocumento" name="numeroDocumento" [formControl]="nroDocumentoValidacion"
								required maxlength="13">
							<mat-error *ngIf="nroDocumentoValidacion.invalid">{{getErrorMessageNroDocumento()}}</mat-error>
							</mat-form-field>
						</div>
						<div style="z-index:99999">
							<re-captcha
							#captchaRef="reCaptcha"
							(resolved)="resolved($event)"
							size="invisible" style="z-index:99999; position: fixed;" ></re-captcha>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="form-group position-center margin-bottom-50">
						<button mat-raised-button color="primary"  (click)="onLoginClick(captchaRef)" [disabled]="!(nroAsambleaValidacion.valid && nroDocumentoValidacion.valid)">INGRESAR</button>
					</div>
				</div>
			</div>
			<div id="logo" class="col-xs-12 col-lg-6 col-md-6" style="text-align: right;">
			<img src="../../../assets/banner-fg.png" alt="banner-fg" height="400px">
			</div>
		</div>
	</form>
  </div>
</div>
